import { create } from 'zustand';
import type { PreferredTiming } from '@/types';

interface SlotSelectionParams {
  // v1.1: the mandatory gate's picker returns BOTH the chosen slot code and the
  // merchant's requested preferred timing bucket (null = Anytime — the slot
  // window is the guarantee, the timing is a best-effort request).
  onSelect: (timeSlotCode: string, preferredTiming?: PreferredTiming | null) => void;
}

interface SlotSelectionState extends SlotSelectionParams {
  isOpen: boolean;
  openSlotSelection: (params: SlotSelectionParams) => void;
  closeSlotSelection: () => void;
}

const defaultValue: SlotSelectionParams = {
  onSelect: () => {},
};

const useSlotSelectionStore = create<SlotSelectionState>((set) => ({
  isOpen: false,
  ...defaultValue,
  openSlotSelection: (params: SlotSelectionParams) =>
    set({
      isOpen: true,
      ...params,
    }),
  closeSlotSelection: () => set({ ...defaultValue, isOpen: false }),
}));

export default useSlotSelectionStore;
